export default function getOpenseaUrl(nftContract, tokenId) {
    return `https://opensea.io/assets/${nftContract}/${tokenId}`
}
